export enum DocumentType {
    LEGAL = "legal",
    TECHNICAL = "technical"
}
